import { ExplorePreferences } from '@citruscamps/citrus-client'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faCircleCheck, faCopy, faShare, faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { useClipboard } from '../../hooks/useClipboard'

interface IState {
  title: string
  description: string
  preferences?: ExplorePreferences
  url: string
  facebookReferalLink: string
  twitterReferalLink: string
  hasShare: boolean
}

interface IProps {
  title?: string
  description?: string
  preferences?: ExplorePreferences
  url?: string
}

export const ShareButtons = (props: IProps) => {
  const [state, setState] = useState<IState | undefined>()
  const { copy: copyToClipboard, isCopied, isCoping } = useClipboard()

  useEffect(() => {
    const title: string = props?.title || 'Share link'
    const description: string = props?.description || ''
    const url: string = props?.url || typeof window !== 'undefined' ? window.location.href : ''
    const facebookReferalLink: string = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url,
    )}`
    const twitterReferalLink: string = `https://twitter.com/share?url=${encodeURIComponent(
      url,
    )}&text=${encodeURIComponent(description)}`
    const hasShare: boolean = typeof window !== 'undefined' && 'share' in navigator
    setState({
      title,
      description,
      preferences: props.preferences,
      url,
      facebookReferalLink,
      twitterReferalLink,
      hasShare,
    })
  }, [props])

  const share = (): void => {
    if (state?.hasShare) {
      const nav = navigator as any
      nav.share({
        title: state?.title,
        text: state?.description,
        url: state?.url,
      })
    } else {
      console.warn('Unable to share link.')
    }
  }

  const shareToFacebook = (event: any): boolean => {
    event.preventDefault()
    window.open(
      state?.facebookReferalLink,
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    )
    return false
  }

  const shareToTwitter = (event: any): boolean => {
    event.preventDefault()
    window.open(
      state?.twitterReferalLink,
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    )
    return false
  }

  return !state ? null : (
    <div className="share-buttons">
      <a
        href={state?.facebookReferalLink}
        className="btn btn-outline-primary rounded px-2 mr-3"
        target="_blank"
        rel="noopener noreferrer"
        onClick={shareToFacebook}
      >
        <FontAwesomeIcon icon={faFacebookF as IconProp} fixedWidth={true} />
        <span className="sr-only">Share on Facebook</span>
      </a>
      <a
        href={state?.twitterReferalLink}
        className="btn btn-outline-primary rounded px-2 mr-3"
        target="_blank"
        rel="noopener noreferrer"
        onClick={shareToTwitter}
      >
        <FontAwesomeIcon icon={faTwitter as IconProp} fixedWidth={true} />
        <span className="sr-only">Share on Twitter</span>
      </a>
      <button
        className="btn btn-outline-primary rounded px-2 mr-3"
        onClick={() => copyToClipboard(state?.url)}
      >
        {!isCoping && !isCopied && <FontAwesomeIcon icon={faCopy} fixedWidth={true} />}
        {isCoping && !isCopied && <FontAwesomeIcon icon={faSpinner} pulse fixedWidth={true} />}
        {isCopied && <FontAwesomeIcon className="fa-beat" icon={faCircleCheck} fixedWidth={true} />}
        <span className="sr-only">Copy to Clipboard</span>
      </button>
      {state?.hasShare ? (
        <button className="btn btn-outline-primary rounded px-2 mr-3" onClick={share}>
          <FontAwesomeIcon icon={faShare} fixedWidth={true} />
          <span className="sr-only">Share</span>
        </button>
      ) : null}
    </div>
  )
}
